// extracted by mini-css-extract-plugin
module.exports = {"container":"submitButton_container__2uYRV","text":"submitButton_text__2fz7u"};